export default __webpack_public_path__ + "static/media/extra-1080.8dde728d.jpg";